import { render, staticRenderFns } from "./StandingOrderTypeForm.vue?vue&type=template&id=57c86cf3"
import script from "./StandingOrderTypeForm.vue?vue&type=script&lang=js"
export * from "./StandingOrderTypeForm.vue?vue&type=script&lang=js"
import style0 from "./StandingOrderTypeForm.vue?vue&type=style&index=0&id=57c86cf3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports